export default __webpack_public_path__ + "static/view-employee-info-02fd907747f9b1ddb84362f491c541b0.png";